export default {
  id: null,
  companyID: null,
  name: null,
  cpfCnpj: null,
  rg: null,
  cnh: null,
  address: null,
  addressNumber: null,
  complement: null,
  district: null,
  zipcode: null,
  stateID: null,
  cityID: null,
  phoneNumber: null,
  cellNumber: null,
  email: false,
  status: true,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/insuredmodel.js